// noinspection DuplicatedCode

import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {UploadedFileType} from '../helpers/file-status.enum';
import {Subject} from 'rxjs';
import {PostalAddress} from '../../../../model/postal-address';
import {CreateDepositService} from '../../../../services/apiServices/business/create-deposit.service';
import {TranslateService} from '@ngx-translate/core';
import {MenuItem, SelectItem} from 'primeng/api';
import {BROWSERS, DeviceDetectorService} from 'ngx-device-detector';
import {ExpressDepositComponent} from '../express-deposit/express-deposit.component';
import {KindOfUpload} from '../helpers/kind-of-upload.enum';
import {StorageService} from '../../../../services/storage/storage.service';
import {Metadata} from '../../../../model/metadata';
import {FileSaverService} from 'ngx-filesaver';
import {CommonService} from '../../../../services/apiServices/business/common.service';
import {DepositDepotExpressEnum} from "../../../../enums/deposit.enums";


@Component({
  selector: 'app-express-mailing',
  templateUrl: './express-mailing.component.html',
  styleUrls: ['./express-mailing.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExpressMailingComponent implements OnInit {

  @ViewChild('customPreviewContainer', {static: false})
  customPreviewContainer: ElementRef;
  @ViewChild('sigContainer', {static: false})
  sigContainer: ElementRef;
  @Output() public shouldClearFiles: Subject<any>;
  @Output() public modalDisplay: EventEmitter<boolean>;


  constructor(private createDepositService: CreateDepositService, private translate: TranslateService,
              private fileSaverService: FileSaverService,
              private commonService: CommonService, private deviceService: DeviceDetectorService,
              private storageService: StorageService) {
    this.shouldClearFiles = new Subject();
    this.modalDisplay = new EventEmitter<boolean>();
  }

  public depositDir;
  public mainFile: File;
  public dataFile: File;
  // public FDP: File;
  public signature: File;
  // public annexes: File[];
  public FileStatus = UploadedFileType;
  public principalFileValidity: boolean;
  public dataFileValidity: boolean;
  public showMailingData: boolean;
  public showMailingDataMail: boolean;
  public dataFileErrors: string[];
  public mailingColumns: string[];
  public showMailingModelEditor: boolean;
  public externalLink: string;
  public mailingData: PostalAddress[];
  public recipientCount: number;
  public mailingDataValidRows: number;
  public mailingDataInValidRows: number;
  public mailingDataValidMailRows: number;
  public mailingDataInValidMailRows: number;

  public selectedMailingAddress: any;
  public selectedMailingAddressLines: string[];
  public selectedMailingAddressIndex: number;
  public showEditMailingAddress: boolean;
  public showEditEmailAddress: boolean;
  public currentStep: string;
  public activeIndex = 0;
  public process: MenuItem[];
  public metaDataList: Metadata[];
  public availableMeta: SelectItem[];
  public availableMetaColumns: SelectItem[];
  public newMeta: Metadata;
  // public metaDayaFields: string[];
  public hasSignature: boolean;
  public hasMailing: boolean;
  public sigPages: any[];
  public displayLoading = false;
  public progressPersisted = 0;
  public savingTrial = 1;
  public progressTimeout = null;
  public persistedCount: number;
  public depositPersisted = false;
  public depositPersistedSerialLot: number = null;
  public templateSource: string;
  public pagesImages: any;
  public pageCount: number;
  sigContainerStyle: any;
  public pages: any[];
  public msBrowsers: boolean;
  public customizedFilePdf: string;
  public pdfToDisplay: any;
  public openVisualization: boolean;
  public foldCount: number;
  displayColumnHelp: boolean;
  ngOnInit() {
    this.displayColumnHelp = false;
    this.newMeta = new Metadata();
    /*this.metaDayaFields = ['persoField1', 'persoField1', 'persoField2', 'persoField4', 'persoField5']*/
    const criteriaFromStorage = this.storageService.getSearchCriteriasFromStorage();
    this.availableMeta = [{label: '', value: ''}];
    this.metaDataList = [];
    for (const c of criteriaFromStorage) {
      if (c.sNameId === 'persoField1' || c.sNameId === 'persoField2' || c.sNameId === 'persoField3' || c.sNameId === 'persoField4' || c.sNameId === 'persoField5' ) {
        this.availableMeta.push({label: c.sLibI18n, value: c.sNameId});
      }
    }
    this.msBrowsers = (BROWSERS.IE === this.deviceService.getDeviceInfo().browser || BROWSERS.MS_EDGE === this.deviceService.getDeviceInfo().browser);
    this.openVisualization = false;
    this.hasSignature = false;
    this.hasMailing = false;
    this.showMailingData = false;
    this.showMailingDataMail = false;
    this.principalFileValidity = false;
    this.dataFileValidity = false;
    this.currentStep = ExpressDepositComponent.PARAMS_STEP;
    this.process = [
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.MAILING.PARAMS')},
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.MAILING.DATA')},
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.MAILING.TEMPLATE')},
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.MAILING.PREVIEW')},
    ];
    /*
    this.postages = [
      {label: 'Ecopli', value: 'ECP'},
      {label: 'Tem\'Post G2', value: 'EG2'},
      {label: 'Tem\'Post G4', value: 'EG4'},
      {label: 'Recommandée France', value: 'ERF'},
      {label: 'Recommandée International', value: 'ERI'}

    ];
    this.selectedPostage = 'ECP';
    this.envelopes = [
      {label: 'C6 (6 pages max)', value: 'C6'},
      {label: 'C4 (40 pages max)', value: 'C4'}
    ];
    this.selectedEnvelope = 'C6';
    this.choicesFDP = [
      {label: this.translate.instant('UPLOAD_COMPONENT.FDP_ON_FIRST'), value: 'FIRST'},
      {label: this.translate.instant('UPLOAD_COMPONENT.FDP_ON_ALL'), value: 'ALL'},
    ];
    this.positionFDP = 'FIRST';*/
    this.sigPages = [];
    this.mailingData = [];
    this.mailingDataValidRows = 0;
    this.mailingDataInValidRows = 0;
    this.mailingDataInValidMailRows = 0;
    this.mailingDataValidMailRows = 0;
  }

  /*  setAnnexesFlag(event: any) {
      setTimeout(() => {
        this.hasAnnexes = event.checked;
      }, 100);
    }*/

  setSignatureFlag(event: boolean) {
    this.hasSignature = event;
    this.process = [
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.MAILING.PARAMS')},
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.MAILING.DATA')},
      {label: this.translate.instant('UPLOAD_COMPONENT.STEPS.MAILING.TEMPLATE')}
    ];
    if (this.hasSignature) {
      this.process.push({label: this.translate.instant('UPLOAD_COMPONENT.STEPS.MAILING.FORMATTING')});
    }
    this.process.push({label: this.translate.instant('UPLOAD_COMPONENT.STEPS.MAILING.PREVIEW')});
  }


  /*
    public setAnnexes(fileType: string, files: File[]) {
      if (!files || files.length < 1) {
        this.annexes = [];
      } else {
        this.annexes = files;
      }
    }

    initArchiving() {
      this.archiving = this.selectedPostage === 'ERF' || this.selectedPostage === 'ERI';
    }

    setFDPFlag(event: any) {
      setTimeout(() => {
        this.hasFDP = event.checked;
      }, 100);
    }*/

  public nextStep() {
    switch (this.currentStep) {
      case ExpressDepositComponent.PARAMS_STEP:
        /*this.storeDepositOptions();*/
        this.currentStep = ExpressDepositComponent.DATA_STEP;
        this.activeIndex++;
        break;
      case ExpressDepositComponent.DATA_STEP:
        this.storeMailingData();
        break;
      case ExpressDepositComponent.TEMPLATE_STEP :
        this.validateModel();
        break;
      case ExpressDepositComponent.FORMATTING_STEP :
        /*if (this.hasSignature) {
          this.storeSignaturePosition();
        } else {
          this.prepareMailingFinalFile({page: 1});
        }*/
        break;
    }
  }

  public storeMailingData() {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    const list = [];
    for (const entry of this.mailingData) {
      list.push({
        fields: entry.userFields,
        lines: entry.formatted,
        countryISOId: entry.sCountryID,
        elements: entry.mElemByName,
        recipientMail: entry.recipientMail
      });
    }
    dataToSend.append('recipient', JSON.stringify(list));
    dataToSend.append('meta', JSON.stringify(this.metaDataList));
    this.createDepositService.storeRecipients(dataToSend).subscribe(response => {
      if (response.recipientCount) {
        this.recipientCount = response.recipientCount;
        this.currentStep = ExpressDepositComponent.TEMPLATE_STEP;
        this.showModelBrowser();
        this.activeIndex++;
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_MSG')
        });
      }
    });
  }

  signaturePositionStored(stored: boolean) {
    if (stored) {
      this.prepareMailingFinalFile({page: 0});
    }
  }

  public nextEnabled(): boolean {
    if (this.currentStep === ExpressDepositComponent.PARAMS_STEP) {
      return true;
    } else if (this.currentStep === ExpressDepositComponent.DATA_STEP) {
      return this.destinationValid();
    } else if (this.currentStep === ExpressDepositComponent.TEMPLATE_STEP) {
      return (this.externalLink && this.externalLink !== '') || (this.mainFile !== null);
    } else if (this.currentStep === ExpressDepositComponent.FORMATTING_STEP) {
      return true;
    } else {
      return true;
    }
  }

  /*public documentIsValid(): boolean {
    return (!this.hasFDP || (this.hasFDP && this.FDP))
      && (!this.hasSignature || (this.hasSignature && this.signature))
      && (!this.hasAnnexes || (this.hasAnnexes && this.annexes !== undefined && this.annexes.length > 0));
  }*/
  public destinationValid(): boolean {
    return this.mailingData && this.mailingData.length > 0 && this.mailingDataInValidRows === 0;
  }

  downloadModel() {
    const content = this.hasMailing
      ? 'Destinataire;Adresse 1;Adresse 2;Adresse 3;Adresse 4;Code Postal;Ville;Pays;Adresses Mail\n'
      : 'Destinataire;Adresse 1;Adresse 2;Adresse 3;Adresse 4;Code Postal;Ville;Pays\n';
    const blob = new Blob([content], {type: 'application/csv'});
    this.fileSaverService.save(blob, 'adresses.csv');
  }

  public getListOfAcceptedFiles(fileStatus: string): string[] {
    switch (fileStatus) {
      case UploadedFileType.MAIN:
        return ['pdf', 'doc'];
      case UploadedFileType.ANNEX:
        return ['pdf', 'doc'];
      case UploadedFileType.DATA:
        return ['xlsx', 'xls', 'csv'];
      default:
        return [];
    }
  }

  public updateUploadValidity(fileType: string, validityFromChild: boolean) {
    switch (fileType) {
      case UploadedFileType.MAIN:
        this.principalFileValidity = validityFromChild;
        break;
      case UploadedFileType.DATA:
        this.dataFileValidity = validityFromChild;
        break;
    }
  }

  public setDataFile(fileType: string, files: File[]) {
    if (files && files.length === 1) {
      this.checkDataFile(files[0]);
    } else {
      this.dataFile = null;
    }
  }

  updateMailingDataCounts() {
    this.mailingDataValidRows = 0;
    this.mailingDataInValidRows = 0;
    this.mailingDataValidMailRows = 0;
    this.mailingDataInValidMailRows = 0;

    if (this.mailingData && this.mailingData.length > 0) {
      for (const entry of this.mailingData) {
        if (entry.isValid()) {
          this.mailingDataValidRows++;
        } else {
          this.mailingDataInValidRows++;
        }

        if (entry.recipientMail && entry.isValidMail()) {
          this.mailingDataValidMailRows++;
        } else {
          this.mailingDataInValidMailRows++;
        }
      }
    }
  }

  public setSignatureFile(file: File) {
    this.signature = file;
    this.setSignatureFlag(file !== null);
  }

  public setHasMailing(boolean: boolean){
    this.hasMailing = boolean;
  }
  /*
    public setFDPFile(fileType: string, files: File[]) {
      if (files && files.length > 0) {
        this.FDP = files[0];
      } else {
        this.FDP = null;
      }
    }*/

  /*private storeDepositOptions() {
    const dataToSend = new FormData();
    dataToSend.append('type', 'MAILING');
    dataToSend.append('postage', this.selectedPostage);
    dataToSend.append('archiving', this.archiving ? 'Y' : 'N');
    dataToSend.append('rectoVerso', this.printingType === 'RV' ? 'Y' : 'N');
    dataToSend.append('colorPrinting', this.printingQuality === 'COLOR' ? 'Y' : 'N');
    dataToSend.append('envelope', this.selectedEnvelope);
    if (this.hasFDP) {
      dataToSend.append('fdp', this.FDP);
      dataToSend.append('positionFDP', this.positionFDP);
    }
    if (this.hasSignature) {
      dataToSend.append('signature', this.signature);
    }
    if (this.hasAnnexes) {
      for (const annex of this.annexes) {
        dataToSend.append('annexes', annex);
      }
    }
    this.createDepositService.storeDepositOptions(dataToSend).subscribe(response => {
      if (response.depositDir) {
        this.depositDir = response.depositDir;
        this.currentStep = ExpressDepositComponent.DATA_STEP;
        this.activeIndex++;
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_STORE_OPTION_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_STORE_OPTION_MSG')
        });
      }
    });
  }*/

  private checkDataFile(file: File) {
    this.showMailingData = false;
    this.showMailingDataMail = false;
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    dataToSend.append('depositType', DepositDepotExpressEnum.MAILING);
    dataToSend.append('dataFile', file);

    this.createDepositService.checkDataFile(dataToSend).subscribe(response => {
      this.availableMetaColumns = [{value: '', label: ''}];
      if (response.dataFileErrors) {
        this.dataFileErrors = response.dataFileErrors;
      }
      if (response.columns) {
        this.mailingColumns = response.columns;
        for (const s of this.mailingColumns) {
          this.availableMetaColumns.push({value: s, label: s});
        }
      }
      if (response.dataFile) {
        this.dataFile = response.dataFile;
        this.mailingData = [];
        let id = 0;
        for (const entry of response.mailingData) {
          entry.id = id;
          id++;
          this.mailingData.push(new PostalAddress(entry));
        }
        this.updateMailingDataCounts();
        if (this.mailingData && this.mailingData.length > 0) {
          this.showMailingData = true;
        }

        if (this.mailingData.some(data => data.recipientMail)) {
          this.showMailingDataMail = true;
        }
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_DATA_MSG')
        });
      }
    });
  }

  public formatAddress(address: PostalAddress): string {
    return address ? address.formatAddress() : '';
  }

  removeInvalidMailingRows() {
    const tempMailingData: PostalAddress[] = [];
    for (const entry of this.mailingData) {
      if (entry.isValid() && (!entry.recipientMail || (entry.recipientMail && entry.isValidMail()))) {
        tempMailingData.push(entry);
      }
    }
    this.mailingData = tempMailingData;
    this.updateMailingDataCounts();
  }

  editMailingAddress(address) {
    this.selectedMailingAddress = address;
    this.selectedMailingAddressLines = address.formatted;
    this.selectedMailingAddressIndex = address.id;
    setTimeout(() => {
      this.showEditMailingAddress = true;
    }, 100);
  }
  removeMailingAddress(address) {
    if (this.mailingData.indexOf(address) > 0) {
      this.mailingData.splice(this.mailingData.indexOf(address), 1);
    }
    this.updateMailingDataCounts();
  }
  updateMailingAddress(address) {
    this.mailingData[this.selectedMailingAddressIndex].formatted = address.fa;
    this.mailingData[this.selectedMailingAddressIndex].valid = true;
    this.mailingData[this.selectedMailingAddressIndex].fields.country = address.country;
    this.updateMailingDataCounts();
    this.selectedMailingAddressIndex = null;
    this.selectedMailingAddress = null;
    this.selectedMailingAddressLines = null;
    this.showEditMailingAddress = false;
  }

  handleDestAddressClose(visible: boolean) {
    this.showEditMailingAddress = visible;
  }

  checkProgress() {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    this.progressTimeout = setInterval(() => {
      this.createDepositService.checkExpressDepositProgress(dataToSend).subscribe(response => {
        if (response.trial) {
          this.savingTrial = response.trial;
        }
        if (response.progress) {
          this.progressPersisted = response.progress;
        }
        if (response.serialLotDepot) {
          this.depositPersistedSerialLot = response.serialLotDepot;
        }
        if (response.status && (response.status === 'FINISHED' || response.status === 'FAILED' || response.status === 'NOT_FOUND')) {
          clearInterval(this.progressTimeout);
        }
      });
    }, 1000);
  }

  closeLoader() {
    this.displayLoading = false;
    this.createDepositService.runningExpressDeposit.emit(this.depositDir);
    this.modalDisplay.emit(false);
  }

  public saveExpressDeposit(): void {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    this.displayLoading = true;
    this.checkProgress();
    this.createDepositService.saveExpressDeposit(dataToSend).subscribe(response => {
      this.displayLoading = false;
      clearInterval(this.progressTimeout);
      if (response.serialLotDepot) {
        this.depositPersistedSerialLot = response.serialLotDepot;
      }
      if (response.foldCount) {
        this.persistedCount = response.foldCount;
        if (this.persistedCount > 0) {
          this.depositPersisted = true;
          this.closeLoader();
        }
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.SAVE_DEPOSIT_ERROR_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.SAVE_DEPOSIT_ERROR_MSG')
        });
      }
    });
  }

/*
  private addExpressMainFile(file: File) {
    const dataToSend = new FormData();
    dataToSend.append('main', file);
    dataToSend.append('depositDir', this.depositDir);
    this.createDepositService.addExpressMainFile(dataToSend).subscribe(response => {
      if (response.depositDir) {
        this.mainFile = file;
        this.nextStep();
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_MSG')
        });
      }
    });
  }
*/

  public setMainFile(fileType: string, files: File[]) {
    if (files && files.length === 1) {
      this.mainFile = files[0];
      // this.addExpressMainFile(files[0]);
      this.validateModel();
    } else {
      this.mainFile = null;
    }
  }

  /*  createNewModel() {
      this.showEditingModel = true;
      this.modelToEdit = null;
    }*/



  validateModel() {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    if (this.mainFile !== null) {
      dataToSend.append('mainFile', this.mainFile);
    }
    this.createDepositService.addExpressMailingModel(dataToSend).subscribe(response => {
      if (response.pageCount) {
        this.pageCount = response.pageCount;
        if (response.hasOwnProperty('pagesImages')) {
          this.pagesImages = {};
          for (let i = 1; i <= response.pagesImages.length; i++) {
            this.pagesImages['page_' + i] = response.pagesImages[i - 1];
          }
        }
        this.pages = [];
        this.sigPages = [];
        for (let index = 1; index <= this.pageCount; index++) {
          this.pages.push({value: index, label: 'Page ' + index});
          this.sigPages.push({value: index, label: 'Sur la page ' + index});
        }
        if (this.hasSignature) {
          this.currentStep = ExpressDepositComponent.FORMATTING_STEP;
          this.activeIndex++;
        } else {
          this.sigContainerStyle = null;
          this.prepareMailingFinalFile({'page': 0});
        }
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_MSG')
        });
      }
    });
  }

  doCreateNewModel() {
    this.createDepositService.createNewLOOLCustomerModel(this.depositDir).subscribe(response => {
      if (response && response.externalLink) {
        this.externalLink = response.externalLink;
        this.showMailingModelEditor = true;
      }
    });
  }

  editorClosed() {
    this.nextStep();
  }

  closeEditor() {
    this.showMailingModelEditor = false;
    this.editorClosed();
  }

  public loadVisualization(openModal: boolean): void {
    if (this.msBrowsers) {
      // TODO find how to preview on MS browsers
    } else {
      if (this.customizedFilePdf) {
        const blob = KindOfUpload.b64toBlob(this.customizedFilePdf);
        this.pdfToDisplay = URL.createObjectURL(blob);
        this.openVisualization = openModal;
      }
    }
  }
  prepareMailingFinalFile(pagination: any) {
    const dataToSend = new FormData();
    dataToSend.append('depositDir', this.depositDir);
    dataToSend.append('foldNumber', '' + pagination.page);
    this.createDepositService.prepareMailingFinalFile(dataToSend).subscribe(response => {
      if (response.pdfFile) {
        if (response.foldCount) {
          this.foldCount = response.foldCount;
        }
        this.customizedFilePdf = response.pdfFile;
        this.foldCount = response.foldCount;
        if (this.currentStep !== ExpressDepositComponent.REVIEW_STEP) {
          this.currentStep = ExpressDepositComponent.REVIEW_STEP;
          this.activeIndex++;
        }
        setTimeout(() => {
          this.pdfToDisplay = null;
          this.loadVisualization(false);
        }, 100);
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.INVALID_MAIN_MSG')
        });
      }
    });

  }

  openEditor() {
    this.templateSource = 'LOOL_ODT';
    this.doCreateNewModel();
  }

  showModelBrowser() {
    this.templateSource = 'USER_PDF';
    // this.doCreateNewModel();
  }

  setDepositDir(value) {
    this.depositDir = value;
  }


  public freeDocMemory(documentToFree): void {
    window.URL.revokeObjectURL(documentToFree);
  }

  removeMeta(toRemove: Metadata) {
    const temp: Metadata[] = [];
    for (const meta of this.metaDataList) {
      if (meta.field !== toRemove.field) {
        temp.push(meta);
      }
    }
    this.metaDataList = temp;
    this.buildAvailableMeta();
  }
  buildAvailableMeta() {
    this.availableMeta = [];
    this.availableMeta.push({label: '', value: ''});
    const criteriaFromStorage = this.storageService.getSearchCriteriasFromStorage();
    for (const c of criteriaFromStorage) {
      if (c.sNameId === 'persoField1' || c.sNameId === 'persoField2' || c.sNameId === 'persoField3' || c.sNameId === 'persoField4' || c.sNameId === 'persoField5' ) {
        let used = false;
        for (const m of this.metaDataList) {
          if (m.field === c.sNameId) {
            used = true;
            break;
          }
        }
        if (!used) {
          this.availableMeta.push({label: c.sLibI18n, value: c.sNameId});
        }
      }
    }
  }
  addMeta() {
    if (this.newMeta.field === '' || this.newMeta.column === '') {
      return;
    }
    this.metaDataList.push({field: this.newMeta.field, column: this.newMeta.column});
    this.newMeta = new Metadata();
    this.buildAvailableMeta();
  }

  getMetaLabel(field: string) {
    const criteriaFromStorage = this.storageService.getSearchCriteriasFromStorage();
    for (const c of criteriaFromStorage) {
      if (c.sNameId === field) {
        return c.sLibI18n;
      }
    }
    return field;
  }

  showColumnHelp() {
    this.displayColumnHelp = true;
  }

  editEmail(email: string, index: number) {
  this.selectedMailingAddress = {email: email, index: index};
    this.showEditEmailAddress = true;
  }


  updateEmailAddress(event: any) {
    this.mailingData[event.index].recipientMail = event.email;
    this.showEditEmailAddress = false;
    this.updateMailingDataCounts();
  }

  protected readonly DepositDepotExpressEnum = DepositDepotExpressEnum;
}
